export const NEGOCIOS = {
  HOME: 'home',
  NEUMATICOS: 'neumaticos',
  BATERIAS: 'baterias',

  ACEITES: 'cambio-de-aceite',
  FRENOS: 'frenos',
  AFINAMIENTO: 'afinamiento-motor',
  AMORTIGUADORES: 'amortiguadores',
  TRENDELANTERO: 'tren-delantero',
  BALANCEO: 'balanceo',
  GEOMETRIA: 'geometria-automotriz',
  KILOMETRAJE: 'mantencion-kilometraje',
  HIGIENIZACION: 'higienizacion',
  FLUIDOS: 'fluidos',
  REVISIONTECNICA: 'revision-tecnica',

  ALINEACION: 'alineacion',
  ELECTRICO: 'electrico-automotriz',
  ACCESORIOS: 'accesorios',

  // locales
  LOCALES: [
    "local-antofagasta",
    "local-chicureo",
    "local-colon",
    "local-concepcion",
    "local-diagonal",
    "local-estoril",
    "local-irarrazaval",
    "local-laflorida",
    "local-laserena",
    "local-maipu",
    "local-penalolen",
    "local-puertomontt",
    "local-rancagua",
    "local-vicmack",
    "local-vina",
    "local-vitacura",
  ],
};

export const COMPLEMENTARIOS = {
  BOLETAS: 'boletas'
};